/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Toast_Create_PlhInputs */

const vi_sl_toast_create_plh = /** @type {(inputs: Sl_Toast_Create_PlhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã tạo phiếu lấy hàng`)
};

/**

* @param {Sl_Toast_Create_PlhInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_toast_create_plh = /** @type {((inputs?: Sl_Toast_Create_PlhInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Toast_Create_PlhInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_toast_create_plh(inputs)
});